var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactSurveyElement } from "./reactquestion_element";
import { ReactElementFactory } from "./element-factory";
import { SvgIcon } from "./components/svg-icon/svg-icon";
var SurveyQuestionSigleInputSummary = /** @class */ (function (_super) {
    __extends(SurveyQuestionSigleInputSummary, _super);
    function SurveyQuestionSigleInputSummary(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionSigleInputSummary.prototype, "css", {
        get: function () {
            return this.props.css;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionSigleInputSummary.prototype, "summary", {
        get: function () {
            return this.props.summary;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionSigleInputSummary.prototype.renderElement = function () {
        if (!this.summary)
            return null;
        return this.summary.isEmpty() ? this.renderNoItems() : this.renderItems();
    };
    SurveyQuestionSigleInputSummary.prototype.renderItems = function () {
        var _this = this;
        return (React.createElement("div", { className: this.css.summary }, this.summary.items.map(function (item, index) { return _this.renderItem(item, index); })));
    };
    SurveyQuestionSigleInputSummary.prototype.renderNoItems = function () {
        var q = this.summary.question;
        var placeholder = ReactElementFactory.Instance.createElement("sv-placeholder-" + q.getTemplate(), { cssClasses: this.css, question: q });
        return placeholder || React.createElement("div", null, this.renderLocString(this.summary.noEntry));
    };
    SurveyQuestionSigleInputSummary.prototype.renderItem = function (item, index) {
        var btnEdit = item.btnEdit ?
            React.createElement("button", { className: this.css.summaryRowActionEdit, onClick: function () { return item.btnEdit.action(); }, title: item.btnEdit.title },
                React.createElement(SvgIcon, { iconName: "icon-editsmall-16x16", iconSize: "auto" })) : null;
        var btnDelete = item.showRemove && item.btnRemove ?
            React.createElement("button", { className: this.css.summaryRowActionDelete, onClick: function () { return item.btnRemove.action(); }, title: item.btnRemove.title },
                React.createElement(SvgIcon, { iconName: "icon-delete-16x16", iconSize: "auto" })) : null;
        return React.createElement("div", { className: this.css.summaryRow, key: index },
            React.createElement("div", { className: this.css.summaryRowContent }, this.renderLocString(item.locText)),
            React.createElement("div", { className: this.css.summaryRowActions },
                btnEdit,
                btnDelete));
    };
    return SurveyQuestionSigleInputSummary;
}(ReactSurveyElement));
export { SurveyQuestionSigleInputSummary };
ReactElementFactory.Instance.registerElement("sv-singleinput-summary", function (props) {
    return React.createElement(SurveyQuestionSigleInputSummary, props);
});
